import { render, staticRenderFns } from "./SettingsNotifications.vue?vue&type=template&id=67b8460e&scoped=true&lang=pug&"
import script from "./SettingsNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingsNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b8460e",
  null
  
)

export default component.exports